//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "~/components/filters.js";
import * as TabLayout from "./tab";
export default {
  components: {
    ...TabLayout,
  },
  data() {
    return {
      active: 0,
    };
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  methods: {
    _getTemplate(tab) {
      let _template = "icon-cards";
      switch (tab.label) {
        case "Support Portal":
          _template = "portal";
          break;
      }

      return _template;
    },
    setHover(event, index) {
      this.active = index;
      const slug = this.$options.filters.slugify(this.menu.tabs[index].label);
      const content = document.querySelector("#" + slug + "-tab");
      const box = event.target.closest(".menu-box").querySelector(".menu-tab-box");

      box.style.height = content.clientHeight + "px";
      box.style.width = content.clientWidth + "px";

      this.$forceUpdate();
    },
  },
};
